<template>
  <div class="eight wide column pl-0 pt-0 pb-05">
    <div class="is-uppercase">
      {{ $t("sends by county") }}
      <div
        class="ui labeled tiny green icon right floated button"
        @click="download"
      >
        <i class="download icon"></i> {{ $t("download") }}
      </div>
    </div>
    <div><canvas id="country_sends"></canvas></div>
  </div>
</template>

<script>
import Chart from "chart.js";
import { groupBy } from "lodash";
// import XLSX from "xlsx";
import { write, utils, writeFile } from "xlsx";
import moment from "moment";

export default {
  name: "CountrySendsGraph",
  props: { stores: Array },
  data() {
    return {
      requests: [],
      // stores: [],
      grps: {},
      chart: undefined,
    };
  },
  mounted() {
    // this.graph();
  },
  computed: {
    grouped() {
      let vm = this;
      if (vm.requests && vm.requests.length > 0) {
        let grps = groupBy(vm.requests, (rq) => {
          let store_id = rq.store_id;

          let store = vm.stores.find((s) => {
            return String(s.store_id) == String(store_id);
          });

          return store ? store.setup.country : store_id;
        });

        return grps;
      } else return [];
    },
  },
  methods: {
    download() {
      let vm = this;
      var wb = utils.book_new();
      wb.Props = {
        Title: "Report",
        Subject: "Report",
      };

      let sheets = Object.keys(vm.grouped).map((k) => {
        return { name: k, data: vm.grouped[k] };
      });

      // console.log(sheets);

      for (let i = 0; i < sheets.length; i++) {
        const sheet = sheets[i];
        wb.SheetNames.push(sheet.name);
        var ws_data = sheet.data.map((d) => {
          return [
            d.create_date,
            // d.setup.customer_name,
            // d.setup.customer_email,
            d.setup.bill_or_ticket_number,
            vm.$t(d.setup.product_type),
            d.nvb_graphic_card.setup.name,
            d.nvb_brand.setup.name,
            d.setup.card_or_notebook_serial,
            // JSON.stringify(d),
          ];
        });
        ws_data.unshift([
          vm.$t("date"),
          // vm.$t("customer name"),
          // vm.$t("customer email"),
          vm.$t("bill or ticket number"),
          vm.$t("product type"),
          vm.$t("gpu"),
          vm.$t("brand"),
          vm.$t("card or notebook serial"),
          // "full",
        ]);
        var ws = utils.aoa_to_sheet(ws_data);
        wb.Sheets[sheet.name] = ws;
      }

      // eslint-disable-next-line no-unused-vars
      var wbout = write(wb, { bookType: "xlsx", type: "binary" });
      writeFile(
        wb,
        `${vm.$t("country report")}_${moment().format("YYYY_MM_DD")}.xlsx`,
      );
    },
    getData() {
      let vm = this;
      return Object.keys(vm.grouped).map((k) => {
        return { name: k, elements: vm.grouped[k].length };
      });
    },
    graph() {
      let vm = this;
      const labels = Object.keys(vm.grouped).map((k) => {
        return k;
      });
      const dt = Object.keys(vm.grouped).map((k) => {
        return vm.grouped[k].length;
      });

      // const labels = ["January", "February", "March", "April", "May", "June"];
      const data = {
        labels: labels,
        datasets: [
          {
            label: vm.$t("codes quantity"),
            data: dt, // [65, 59, 80, 81, 56, 55, 40],
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(255, 159, 64, 0.2)",
              "rgba(255, 205, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(201, 203, 207, 0.2)",
            ],
          },
        ],
      };

      vm.grps = data;

      const ctx = document.getElementById("country_sends");
      let dtt = JSON.parse(JSON.stringify(data));

      const alwaysShowTooltip = {
        id: "alwaysShowTooltip",
        afterDraw(chart /* args, options */) {
          // console.log(args, options);
          const { ctx } = chart;
          ctx.save();
          chart.data.datasets.forEach((dataset, i) => {
            chart.getDatasetMeta(i).data.forEach((datapoint, index) => {
              const { x, y } = datapoint.tooltipPosition();
              // console.log(x, y, index);

              const text = chart.data.datasets[i].data[index];
              ctx.fillStyle = "rgba(0,0,0,0.8)";
              ctx.fillText(text, x, y - 10);
              // ctx.fillRect(x, y, 30, 30);
              // console.log(text, textWidth);
            });
          });
        },
      };

      const config = {
        type: "bar",
        data: dtt,
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: "top",
            },
            title: {
              display: true,
              text: "Chart.js Pie Chart",
            },
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  callback: function (value) {
                    if (Number.isInteger(value)) {
                      return value;
                    }
                  },
                },
              },
            ],
          },
        },
        plugins: [alwaysShowTooltip],
      };

      if (vm.chart) vm.chart.destroy();
      const myChart = new Chart(ctx, config);
      vm.chart = myChart;

      // eslint-disable-next-line no-unused-vars
      // const myChart = new Chart(
      //   document.getElementById("country_sends"),
      //   config,
      // );
      // myChart.setOptions({
      //   responsive: true,
      //   maintainAspectRatio: false,
      // });
    },
    setRequests(requests) {
      this.requests = requests;
      this.graph();
    },
    // setStores(stores) {
    //   this.stores = stores;
    // },
  },
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

/*  SPACING   */
.py-05 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.m-0 {
  margin: 0 !important;
}
.my-0 {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
.pl-0 {
  padding-left: 0 !important;
}

/*  FONTS   */
.has-text-centered {
  text-align: center !important;
}
.has-text-left {
  text-align: left !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}

/*  GRAFICAS    */
.charts-nvidia div .is-uppercase {
  background-color: #666666 !important;
  color: white !important;
  padding: 0.5rem 1rem 0.5rem;
}

/* INFORMACION BUNDLE*/
.info-bundle .ten table tbody tr td {
  text-align: center;
  font-size: 90% !important;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.info-bundle .ten table tbody tr td button {
  font-size: 90% !important;
}
.info-bundle .ten table tbody tr .six.wide button {
  border-radius: 2rem;
}
.info-bundle .six table tbody tr td {
  text-align: left;
  font-size: 90% !important;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.info-bundle .six table tbody tr td button {
  font-size: 90% !important;
}
.info-bundle .six table tbody tr .six.wide button {
  border-radius: 2rem;
}
.ibundle-button-green {
  background-color: #666666 !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.ibundle-button-green.active {
  background-color: #365a0c !important;
}
.ibundle-button-green:hover {
  background-color: #365a0c !important;
}

/*  MODAL FORMS   */
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}

/*  HISTORIAL DE ENVIOS */
.sb-button {
  display: flex !important;
  flex-direction: row;
  text-align: left !important;
  background-color: transparent !important;
  color: #606060 !important;
}
.sb-button:hover {
  color: white !important;
  background-color: #365a0c !important;
}
.sb-button.active {
  color: white !important;
  background-color: #365a0c !important;
}
.pre-sb-button {
  flex: 20%;
}
.name-sb-button {
  flex: 80%;
}
</style>
